import { BetSelection } from '../hooks/types';
import { isVoidedResult } from './is-voided-result';

export const isSelectionInactive = (selection: Pick<BetSelection, 'result' | 'feature_flags'>): boolean =>
    selection.result === 'CASHEDOUT' ||
    (isVoidedResult(selection.result) && !selection.feature_flags?.includes('REVIVE'));
